import * as React from 'react';
import { makeStyles, Grid, Typography } from '@material-ui/core';
import { observer } from 'mobx-react-lite';

const useStyles = makeStyles(theme => ({
	titleContainer: {
		float: 'left',
		textAlign: 'left',
		margin: '4px',
		padding: '16px 6px',
	},
	title: {
		font: 'normal normal normal 18px/12px Roboto',
		color: '#002855',
		fontSize: '18px',
	},
}));

const PageTitle: React.FunctionComponent = observer(({ children }: { children: any }) => {
	const classes = useStyles();
	return (
		<Grid item xs className={classes.titleContainer}>
			<Typography variant="subtitle2" className={classes.title}>
				{children}
			</Typography>
		</Grid>
	);
});

export default PageTitle;
